<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-chair`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37 2a1 1 0 011 1v22h4a1 1 0 011 1v2a1 1 0 01-1 1h-2.001L40 45a1 1 0 01-1 1h-2a1 1 0 01-1-1l-.001-10H12v10a1 1 0 01-1 1H9a1 1 0 01-1-1V29H6a1 1 0 01-1-1v-2a1 1 0 011-1h4V3a1 1 0 011-1h26zm-1.001 27H12v2h23.999v-2zM34 12H14v13h20V12zm0-6H14v2h20V6z"/></svg>
</template>
<script>

export default {
  name: 'IconChair',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
